/* Vault 88 — CRM form engine (2026-10-14).
   Every on-site signup posts straight to Klaviyo (Client Subscriptions API,
   public company id — no secret keys) instead of Shopify's native customer
   form. One list (Email List → triggers the Welcome Series flow); each
   placement passes its own `data-source`, which Klaviyo stores as the
   profile's custom source so signups can be reported per page/placement.

   Markup contract:
     <form data-v88-crm data-source="Footer — Drop List">
       <input type="email" data-crm-email required>
       <input type="tel" data-crm-phone>            (optional)
       <input type="checkbox" data-crm-sms>         (required if phone filled)
       <p data-crm-msg hidden></p>
       <button type="submit">…</button>
     </form>
   On success the form gets .is-done and fires `v88crm:success` (bubbles). */
(function () {
  if (window.__v88crm) return;
  window.__v88crm = true;

  var COMPANY = 'TwKmdB';
  var LIST = 'RcwVuf'; /* Klaviyo "Email List" — Welcome Series trigger */
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions?company_id=' + COMPANY;

  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function toE164(raw) {
    var d = (raw || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    if (d.length === 10) return '+1' + d;
    return '';
  }

  function payload(email, phone, source) {
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var attrs = { email: email, properties: { v88_signup_source: source, v88_signup_page: location.pathname } };
    if (phone) {
      attrs.phone_number = phone;
      subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    attrs.subscriptions = subs;
    return JSON.stringify({
      data: {
        type: 'subscription',
        attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: LIST } } }
      }
    });
  }

  function send(email, phone, source) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' },
      body: payload(email, phone, source)
    }).then(function (r) {
      if (r.status >= 200 && r.status < 300) return true;
      /* SMS consent can be rejected (e.g. number not textable) — keep the email signup */
      if (phone) return send(email, '', source);
      throw new Error('status ' + r.status);
    });
  }

  function msg(form, text, ok) {
    var el = form.querySelector('[data-crm-msg]');
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
    el.classList.toggle('is-ok', !!ok);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-v88-crm')) return;
    e.preventDefault();
    if (form.classList.contains('is-busy')) return;

    var hp = form.querySelector('[data-crm-hp]');
    if (hp && hp.value) return;

    var emailEl = form.querySelector('[data-crm-email]');
    var phoneEl = form.querySelector('[data-crm-phone]');
    var smsEl = form.querySelector('[data-crm-sms]');
    var email = emailEl ? emailEl.value.trim() : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg(form, 'Enter a valid email address.'); return; }

    var phone = '';
    var rawPhone = phoneEl ? phoneEl.value.trim() : '';
    if (rawPhone) {
      phone = toE164(rawPhone);
      if (!phone) { msg(form, 'Use a 10-digit US mobile number, or leave it blank.'); return; }
      if (!smsEl || !smsEl.checked) { msg(form, 'Check the SMS box to get texts, or clear the phone field.'); return; }
    }

    var source = form.getAttribute('data-source') || 'Website';
    form.classList.add('is-busy');
    msg(form, '');

    send(email, phone, source).then(function () {
      form.classList.remove('is-busy');
      form.classList.add('is-done');
      lsSet('v88_subscribed', '1');
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
      msg(form, form.getAttribute('data-success') || "You're on the list — watch your inbox for the next vault.", true);
      form.dispatchEvent(new CustomEvent('v88crm:success', { bubbles: true, detail: { email: email, sms: !!phone, source: source } }));
    }).catch(function () {
      form.classList.remove('is-busy');
      msg(form, 'That didn’t go through — check your connection and try again.');
    });
  });
})();
